import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { AuthService } from '../../../../services/auth.service';
import { AngularFireStorage } from '@angular/fire/storage';
import { Router } from '@angular/router';

@Component({
  selector: 'form-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class FormProfileComponent implements OnInit {
  errors: string[] = [];
  // avatarFile: any;
  // headerFile: any;
  // vrmFile: any;
  // file2048: any[];
  // filemoc: any;
  // filemodel: any;
  // filephysics: any;
  // isCompleted: boolean = false;
  // uploadFile2048: any[];
  // isLinkFailed: boolean = false;

  @Input() profileForm: any;
  @Input() fileObjs: any;
  @Output() saveProfile = new EventEmitter();

  constructor(public auth: AuthService,
    private afStorage: AngularFireStorage,
    private router: Router) {}

  ngOnInit() {
    // this.fileObjs.file2048 = this.profileForm.live2d.file2048.map(item => undefined)
  }

  checkInvalid() {
  }

  openFileBrowser(event: any, fileReference: string) {
    event.preventDefault();

    let element: HTMLElement = document.getElementById(fileReference) as HTMLElement;
    element.click();
}

  onFileChange(event: any, fileReference: string, index: number = 0) {
    let files = event.target.files;

    let reader = new FileReader();
    reader.onload = (e: any) => {
      switch (fileReference) {
        case 'avatar':
          this.profileForm.photoURL = e.target.result;
          break;
        case 'header':
          this.profileForm.headerURL = e.target.result;
          break;
      }
    }

    switch (fileReference) {
      case 'avatar':
        if (this.validImageFile(files[0], 'invalid-avatar')) {
          this.fileObjs.avatarFile = files[0];
          reader.readAsDataURL(files[0]);
        }
        break;
      case 'header':
        if (this.validImageFile(files[0], 'invalid-header')) {
          this.fileObjs.headerFile = files[0];
          reader.readAsDataURL(files[0]);
        }
        break;
      case 'vrm':
        if (this.validFile(files[0], '.vrm', 'invalid-vrm-file')) {
          this.fileObjs.vrmFile = files[0];
          this.profileForm.vrm.filename = files[0].name;
        }

        break;
      case '2048':
        if (this.validFile(files[0], '.png', 'invalid-2048-file' + index)) {
          this.fileObjs.file2048[index] = files[0];
          this.profileForm.live2d.file2048[index].filename = files[0].name;
        }

        break;
      case 'moc':
        if (this.validFile(files[0], '.moc', 'invalid-moc-file') || this.validFile(files[0], '.moc3', 'invalid-moc-file')) {
          this.fileObjs.filemoc = files[0];
          this.profileForm.live2d.filemoc.filename = files[0].name;
        }

        break;
      case 'model':
        if (this.validFile(files[0], '.model.json', 'invalid-model-file') || this.validFile(files[0], '.model3.json', 'invalid-model-file')) {
          this.fileObjs.filemodel = files[0];
          this.profileForm.live2d.filemodel.filename = files[0].name;
        }

        break;
      case 'pose':
        if (this.validFile(files[0], '.pose.json', 'invalid-pose-file') || this.validFile(files[0], '.pose3.json', 'invalid-pose-file')) {
          this.fileObjs.filepose = files[0];
          this.profileForm.live2d.filepose.filename = files[0].name;
        }

        break;
      case 'physics':
        if (this.validFile(files[0], '.physics.json', 'invalid-physics-file') || this.validFile(files[0], '.physics3.json', 'invalid-physics-file')) {
          this.fileObjs.filephysics = files[0];
          this.profileForm.live2d.filephysics.filename = files[0].name;
        }

        break;
    }
  }

  removeFile(fileReference, index: number = 0) {
    switch (fileReference) {
      case 'vrm':
        this.fileObjs.vrmFile = undefined;
        this.profileForm.vrm.filename = undefined

        break;
      case '2048':
        this.fileObjs.file2048 = this.fileObjs.file2048.map((item, ind) => index === ind ? undefined : item)
        this.profileForm.live2d.file2048[index].filename = undefined

        break;
      case 'moc':
        this.fileObjs.filemoc = undefined;
        this.profileForm.live2d.filemoc.filename = undefined

        break;
      case 'model':
        this.fileObjs.filemodel = undefined;
        this.profileForm.live2d.filemodel.filename = undefined

        break;
      case 'pose':
        this.fileObjs.filepose = undefined;
        this.profileForm.live2d.filepose.filename = undefined

        break;
      case 'physics':
        this.fileObjs.filephysics = undefined;
        this.profileForm.live2d.filephysics.filename = undefined

        break;
    }
  }

  validFile(file, extension, error) {
    if (!file.name.endsWith(extension)) {
      if (!this.hasError(error)) {
        this.errors.push(error);
      }
      return false;
    }

    this.removeErrorMessage(error);

    return true;
  }

  validImageFile(file, error) {
    if (!file.type.startsWith('image')) {
      if (!this.hasError(error)) {
        this.errors.push(error);
      }
      return false;
    }

    this.removeErrorMessage(error);

    return true;
  }

  removeErrorMessage(error) {
    if (this.hasError(error)) {
      this.errors = this.errors.filter(item => item !== error)
    }
  }

  canSave() {
    if (this.profileForm.name === '' || this.profileForm.title === '' || this.profileForm.title.length > 64 || this.profileForm.photoURL === '' || this.profileForm.photoURL === undefined || this.profileForm.headerURL === '' || this.profileForm.headerURL === undefined || this.profileForm.description === '') {
      return false;
    }

    return true;
  }

  hasError(value: string): boolean {
    return this.errors.indexOf(value) >= 0;
  }

  uploadPhoto(file, filename) {
    let ref = this.afStorage.ref("/users/" + this.auth.user.uid + '/' + filename);
    let task = ref.put(file);

    return task
  }

  addMore() {
    this.fileObjs.file2048.push(undefined)
    this.profileForm.live2d.file2048.push({filename: '', url: ''})
  }

  deleteFile2048(index) {
    this.fileObjs.file2048 = this.fileObjs.file2048.filter((item, ind) => ind !== index)
    this.profileForm.live2d.file2048 = this.profileForm.live2d.file2048.filter((item, ind) => ind !== index)
  }

  async save() {
    this.saveProfile.emit()
  }

  changeStatusLabel(profile) {
    if (profile.status === 'review') return '変更申請中'
    if (profile.status === 'approve') return '承認済み'
    if (profile.status === 'reject') return '承認不可'

    return '変更未申請'
  }

  twitterLink() {
    this.auth.twitterLink()
    .then((response) => {
      this.profileForm.twitter_url = "https://twitter.com/" + response.additionalUserInfo.username
      this.auth.updateUserData({
        uid: this.auth.user.uid,
        twitter_url: this.profileForm.twitter_url
      })
    })
    .catch(error => {
      this.fileObjs.isLinkFailed = true;
    })
  }

  twitterUnlink() {
    this.profileForm.twitter_url = ''
    this.auth.unlink('twitter.com')

    this.auth.updateUserData({
      uid: this.auth.user.uid,
      twitter_url: ''
    })
  }

  googleLink() {
    this.auth.googleLink()
    .then((response) => {
      console.log(response)
      this.profileForm.youtube_url = "https://google.com/" + response.additionalUserInfo.username
      // let token = response.credential.accessToken;

      this.auth.updateUserData({
        uid: this.auth.user.uid,
        youtube_url: this.profileForm.youtube_url
      })
    })
    .catch(error => {
      this.fileObjs.isLinkFailed = true;
    })
  }

  googleUnlink() {
    this.profileForm.youtube_url = ''
    this.auth.unlink('google.com')

    this.auth.updateUserData({
      uid: this.auth.user.uid,
      youtube_url: ''
    })
  }
}
